<button
	[class.svg]="icon"
	[class.icon-right]="iconRight"
	[class.full-width]="fullWidth"
	[class.lower]="lowerHeight"
	[class.auto]="autoHeight"
	[disabled]="!enabled"
	[class.disabled]="!enabled"
	[class.hovering]="hovering"
	[class]="buttonType"
	(click)="click($event)"
>
	<ng-content></ng-content>
	@if (icon) {
		<app-icon [name]="icon" size="small"></app-icon>
	}
</button>
